import React from 'react';

import PropTypes from 'prop-types';

import { isInFuture, isInPast } from '@src/utils/dateTimeHelpers';

const StatusLabels = ({ expiredAt, status, publishedAt, archivedAt }) => {
    const labels = [];
    if (status === 'draft') {
        labels.push(<span key={`status-label-${status}`} className="text-danger text-uppercase mr-1">[Draft]</span>);
    }

    if (status === 'published' && isInFuture(publishedAt)) {
        labels.push(<span key={`status-label-${status}`} className="text-warning text-uppercase mr-1">[Scheduled]</span>);
    }

    if (isInPast(expiredAt)) {
        labels.push(<span key="status-label-expired" className="text-danger text-uppercase mr-1">[Expired]</span>);
    }

    if (isInPast(archivedAt)) {
        labels.push(<span key="status-label-archived" className="alert-archived text-uppercase mr-1">[Archived]</span>);
    }

    return labels;
};

StatusLabels.propTypes = {
    expiredAt: PropTypes.string,
    status: PropTypes.oneOf(['draft', 'published', 'active', 'lifted', 'updated']),
    publishedAt: PropTypes.string,
    archivedAt: PropTypes.string,
};

export default StatusLabels;
